import React from 'react';
import { Route, Switch,HashRouter} from 'react-router-dom';
import Index from './components/Index.jsx';//首页
import From from './components/From.jsx';//首页
import Order from './components/Order.jsx';//订单
import Detail from './components/OrderDetail.jsx';//订单详情
import admin from './components/Admin.jsx';//统计数据表格页面（独立页面）
const BasicRoute = () => (
    <HashRouter>
        <Switch>
            <Route exact path="/" component={Index} />
            <Route exact path="/index" component={Index} />
            <Route exact path="/index/from/:code/:name" component={From} />
            <Route exact path="/order" component={Order} />
            <Route exact path="/order/detail/:type/:serId" component={Detail} />
            <Route exact path="/admin" component={admin} />
        </Switch>
    </HashRouter>
);

function App() {
	return (
		<BasicRoute />
	);
}

export default App;
